import { render, staticRenderFns } from "./MailSend.vue?vue&type=template&id=8d463c90&"
import script from "./MailSend.vue?vue&type=script&lang=js&"
export * from "./MailSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports